import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../../../../screens/communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LikeCommentMutationVariables = Types.Exact<{
  commentId: Types.Scalars['ID']['input'];
}>;


export type LikeCommentMutation = { __typename?: 'Mutation', likeComment: { __typename?: 'CommentLike', id: string, createdAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } } };

export type RemoveLikeFromCommentMutationVariables = Types.Exact<{
  likeId: Types.Scalars['ID']['input'];
}>;


export type RemoveLikeFromCommentMutation = { __typename?: 'Mutation', removeLikeFromComment: { __typename?: 'CommentLike', id: string } };


export const LikeCommentDocument = gql`
    mutation LikeComment($commentId: ID!) {
  likeComment(data: {commentId: $commentId}) {
    id
    createdAt
    author {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;

/**
 * __useLikeCommentMutation__
 *
 * To run a mutation, you first call `useLikeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeCommentMutation, { data, loading, error }] = useLikeCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useLikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeCommentMutation, LikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeCommentMutation, LikeCommentMutationVariables>(LikeCommentDocument, options);
      }
export type LikeCommentMutationHookResult = ReturnType<typeof useLikeCommentMutation>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export type LikeCommentMutationOptions = Apollo.BaseMutationOptions<LikeCommentMutation, LikeCommentMutationVariables>;
export const RemoveLikeFromCommentDocument = gql`
    mutation RemoveLikeFromComment($likeId: ID!) {
  removeLikeFromComment(data: {likeId: $likeId}) {
    id
  }
}
    `;
export type RemoveLikeFromCommentMutationFn = Apollo.MutationFunction<RemoveLikeFromCommentMutation, RemoveLikeFromCommentMutationVariables>;

/**
 * __useRemoveLikeFromCommentMutation__
 *
 * To run a mutation, you first call `useRemoveLikeFromCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLikeFromCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLikeFromCommentMutation, { data, loading, error }] = useRemoveLikeFromCommentMutation({
 *   variables: {
 *      likeId: // value for 'likeId'
 *   },
 * });
 */
export function useRemoveLikeFromCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLikeFromCommentMutation, RemoveLikeFromCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLikeFromCommentMutation, RemoveLikeFromCommentMutationVariables>(RemoveLikeFromCommentDocument, options);
      }
export type RemoveLikeFromCommentMutationHookResult = ReturnType<typeof useRemoveLikeFromCommentMutation>;
export type RemoveLikeFromCommentMutationResult = Apollo.MutationResult<RemoveLikeFromCommentMutation>;
export type RemoveLikeFromCommentMutationOptions = Apollo.BaseMutationOptions<RemoveLikeFromCommentMutation, RemoveLikeFromCommentMutationVariables>;